import React from 'react';
import PropTypes from 'prop-types';

const InputCheckbox = ({ name, label, style, touched, error, onChange, checked }) => {
  const classes = ['input-checkbox'];
  const disabled = !onChange;

  if (checked) {
    classes.push('input-checkbox--checked');
  }

  if (style) {
    classes.push(`input-checkbox--${style}`);
  }

  return (
    <label className={classes.join(' ')}>
      {label}
      <input type="checkbox" name={name} checked={checked} onChange={onChange} disabled={disabled} />
      <span className="input-checkbox__checkmark"></span>
    </label>
  );
};

export default InputCheckbox;
